const config = {
    //BASE_URL: 'https://epicpay.onrender.com',
     //BASE_URL: 'http://96.127.218.7:4000',
     // BASE_URL: 'http://192.168.7.8:4000'
     BASE_URL:"https://flixroot.onrender.com"
      };
        export default config;